import { APIForVolunteerV3V2 } from ".";

export const getAllNewsList = (langNumber) =>
  APIForVolunteerV3V2.get(`news_list?language=${langNumber}`);

export const getAllGalleryImageList = () => APIForVolunteerV3V2.get(`gallery`);
